import { Outlet, createFileRoute, redirect } from '@tanstack/react-router'

/**
 * Layout pro neprihlasene (prihlaseni, registrace).
 *
 * Podtrzitko v nazvu znamena, ze cesta nema vlastni segment v URL — soubor
 * `_auth.login.tsx` proto vede na /login, ne na /_auth/login.
 */
export const Route = createFileRoute('/_auth')({
  beforeLoad: ({ context }) => {
    // Prihlaseneho uz nema smysl poustet na prihlasovaci formular.
    if (context.auth.isAuthenticated) {
      throw redirect({ to: '/dashboard' })
    }
  },
  component: () => (
    <div className="flex min-h-screen items-center justify-center bg-slate-50 px-4">
      <div className="w-full max-w-md">
        <div className="mb-6 text-center">
          <h1 className="text-2xl font-bold text-brand-700">monitoring</h1>
          <p className="mt-1 text-sm text-slate-500">Dohled nad dostupnosti sluzeb</p>
        </div>
        <Outlet />
      </div>
    </div>
  ),
})
